import { color } from "@mui/system";
import React, { useRef, useState, useEffect } from "react";
import SparklyBorder from "../SparklyBorders/SparklyBorderWithoutSVG";

export default function UltraLuxInput({
  label = "Customer Name",
  type="text",
  value,
  onChange,
  list = "list_customer",
  disabled = false,
}) {
  const [focused, setFocused] = useState(false);
  const [hovered, setHovered] = useState(false);
  const inputRef = useRef(null);

  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setSize({ width: rect.width, height: rect.height });
    }
    // Optional: handle window resize
    const handleResize = () => {
      if (inputRef.current) {
        const rect = inputRef.current.getBoundingClientRect();
        setSize({ width: rect.width, height: rect.height });
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  return (
    <div style={{ 
      position: "relative", 
      width: "60%",
      justifyContent:"center",
      alignItems:"center",
      padding: ".2vw 0" 
      }}>
      <style>{`
        @keyframes shimmerFlow {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }

        @keyframes fadeSlideUp {
          0% { opacity: 0; transform: translateY(20px) scale(0.98); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }

        @keyframes blinkText {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes orbit {
          0% { transform: rotate(0deg) translateX(7vw) rotate(0deg); }
          100% { transform: rotate(360deg) translateX(7vw) rotate(-360deg); }
        }

        @keyframes borderFlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        @keyframes sparkRun {
          0%   { top: 22%; left: 0; }
          25%  { top: 22%; left: 75%; transform: translateX(-90%); }
          50%  { top: 70%; left: 75%; transform: translate(-90%, -80%); }
          75%  { top: 70%; left: 0; transform: translateY(-60%); }
          100% { top: 22%; left: 0; }
        }

        @keyframes sparkleTwinkle {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.5); opacity: 0.8; filter: blur(1px); }
          100% { transform: scale(1); opacity: 1; filter: blur(0.3px); }
        }

        @keyframes trailFadeHorizontal {
          0% { opacity: 1; transform: scaleX(1) }
          25% { opacity: 1; transform: scaleX(1) }
          50% { opacity: 1; transform: scaleX(1)  }
          75% { opacity: 1; transform: scaleX(1)  }
          100% { opacity: 1; transform: scaleX(1) }


        }

        @keyframes trailFadeVertical {
          0% { opacity: 1; transform: scaleX(1)}
          25% { opacity: 1; transform: scaleX(1)}
          50% { opacity: 1; transform: scaleX(1)  }
          75% { opacity: 1; transform: scaleX(1)  }
          100% { opacity: 1; transform: scaleX(1) }


        }
        
        .lux_input {
          // width: 100%;
          // height:1vh,
          padding: 1.2vw 1vw;
          font-size: 1.1vw;
          font-weight: 800;
          color: #000;
          transform: translate(50%, 0%);
          background: rgba(255, 255, 255, 0.05);
          border: 2px solid rgba(255, 255, 255, 0.15);
          border-radius: 1vw;
          outline: none;
          backdrop-filter: blur(14px);
          transition: all 0.4s ease;
          animation: fadeSlideUp 1s ease;
          box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.05),
                      0 0 25px rgba(255, 105, 180, 0.15);
        }

        .lux_input:hover {
          border-color: rgba(255, 182, 193, 0.5);
          box-shadow: 0 0 25px rgba(255, 20, 147, 0.3),
                      inset 0 0 15px rgba(255, 255, 255, 0.1);
        }

        .lux_input:focus {
          border-color: #ff69b4;
          box-shadow: 0 0 35px rgba(255, 105, 180, 0.6),
                      inset 0 0 20px rgba(255, 255, 255, 0.2);
          background: rgba(255, 255, 255, 0.08);
        }

        .lux_label {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-40%, -50%);
          color: #ffffff;
          font-size: 1.5vw;
          font-weight: 800;
          pointer-events: none;
          transition: all 0.5s ease-in-out;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1)
          );

          animation: shimmerFlow 9s linear infinite;
          z-index: 5;
        }
        
        .lux_label.active {
          top: 50%; /* keep same vertical alignment */
          left: 1vw; /* shift horizontally only */
          transform: translate(-15%, -50%); /* maintain vertical centering */
          font-size: .5vw;
          color: #847f81;

          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1)
          );
          
          background-size: 100% auto;
          // -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
        }
        
        .lux_input:disabled {
          opacity: 0.5;
          filter: grayscale(60%);
          cursor: not-allowed;
          box-shadow: none;
        }
      `}</style>

      <div
        style={{

        }}
      >

        <label
          className={`lux_label ${focused || value ? "active" : ""
            }`}
          style={{
            fontSize: focused || value ? "1.5vh" : "1.5vh",
            fontWeight: focused || value ? "1800" : "bold",
            width: focused || value ? "4vw" : "5vw",
            height: "1vh",
            color: focused || value ? "#000000" : "#cec8ca",
            borderRadius: ".1vw",
            marginTop: ".2vh",
            // border: focused || value ? "0.05vw solid #ff69b4" : " ",
            boxShadow: focused || value ? "2vw solid #000000" : " ",

            background: focused || value
              ? "rgba(255, 230, 240, .3)"
              : "transparent", // ✅ white background when inside
            animation: focused ? (value ? "none" : "blinkText 1s infinite") : "none", // ✨ blinking effect
            marginRight: focused || value ? ".1vh" : "",
          }}
        >
          {label}


        </label>

      </div>



      <div
        style={{
          position: "relative",
          display: "inline-block",
          width: "100px",
        }}
      >
        <input
          style={{

          }}
          ref={inputRef}
          type={type}
          className="lux_input"
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          list={list}
          disabled={disabled}

        />

        {
          focused &&
          (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                pointerEvents: "none",
                transform: "translate(50%, 0%)"
              }}
            >
              <SparklyBorder
                width={size.width}
                height={size.height}
                radius={6}
                speed={65}
              />
            </div>
          )}



      </div>



    </div>
  );
}
